import { useTranslation } from 'react-i18next'

import fileSaver from 'file-saver'

import { ReservationDto } from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'

import { useVoucher } from '@/entities/reservation'
import { cn } from '@/shared/lib/cn'
import { Button } from '@/shared/ui/Button'

import { showDownloadVoucher } from '../../config/showDownloadVoucher.ts'

const { saveAs } = fileSaver

interface DownloadVoucherProps {
	reservationId: ReservationDto['reservationId']
	offer: Offer
	className?: string
}

/**
 *
 *
 * @author Ivan Shchedrovskyi
 */
export const DownloadVoucher = ({
	className,
	reservationId,
	offer
}: DownloadVoucherProps) => {
	const { t } = useTranslation('room-page', {
		keyPrefix: 'reservationTab.contactProperty'
	})

	const { refetch, isFetching } = useVoucher(reservationId)

	const handleClick = async () => {
		const data = await refetch()

		if (data.data === undefined) {
			throw new Error('Something went wrong')
		}

		saveAs(
			data.data,
			`${offer.roomDynamic.name}_${offer.roomDynamic.checkIn}-${offer.roomDynamic.checkOut}.pdf`
		)
	}

	return (
		<Button
			className={cn(
				'ts-hyperlink-button-2! h-auto justify-start p-0',
				!showDownloadVoucher.includes(offer.IDs.status) && 'hidden',
				className
			)}
			variant="link"
			onClick={handleClick}
			isLoading={isFetching}
		>
			{t('downloadVoucher')}
		</Button>
	)
}

DownloadVoucher.displayName = 'DownloadVoucher'
